import { createAction } from "@logicsoftware/redux-toolkit";
import { ReInit, ReinitActionTypes } from "~/Redux/AppReinit";

export interface CurrentPresetState {
    currentPresetId?: number;
}

export const setCurrentPresetInStore = createAction("SET_REQUESTING_PRESET", (value: number) => ({ payload: value }));

type Actions = ReturnType<typeof setCurrentPresetInStore> | ReInit;

export const initPresetState: CurrentPresetState = {
    currentPresetId: null,
};

export const currentPresetReducer = (
    state: CurrentPresetState = initPresetState,
    action: Actions
): CurrentPresetState => {
    if (action.type === setCurrentPresetInStore.type) {
        return { ...state, currentPresetId: action.payload };
    }

    if (action.type === ReinitActionTypes.APP_REINIT) {
        return { ...initPresetState };
    }

    return state;
};
